import Cookies from "universal-cookie"

const COOKIES = new Cookies()

export { COOKIES }